export const APPLICATION_CV_MAX_BYTES = 5 * 1024 * 1024;

export function applicationCvError(file) {
  if (!file) return '';
  if (!/\.pdf$/i.test(file.name || '') || (file.type && file.type !== 'application/pdf')) {
    return 'Please choose a PDF file for your CV.';
  }
  if (!file.size) return 'Your CV file is empty. Please choose a PDF with content.';
  if (file.size > APPLICATION_CV_MAX_BYTES) return 'Your CV must be 5 MB or smaller. Please choose a smaller PDF.';
  return '';
}
